import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography, Grid } from '@mui/material';

import DialecticaLogo from '../../icons/DialecticaLogo';
import { useAppState } from '../../state';
import InviteButton from '../CallInvite/InviteButton';
import TroubleshootButton from '../Buttons/TroubleshootButton';

const HeaderContainer = styled('header')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  top: 0,
  left: 0,
  right: 0,
  height: `${theme.headerHeight}px`,
  position: 'fixed',
  display: 'flex',
  padding: '0 1.43em',
  zIndex: 10,
  [theme.breakpoints.down('sm')]: {
    height: `${theme.mobileFooterHeight}px`,
    padding: 0,
  },
}));

const Logo = styled(DialecticaLogo)({
  height: '40px',
});

const MobileMenu = styled(Grid)(({ theme }) => ({
  visibility: 'hidden',
  [theme.breakpoints.down('sm')]: {
    visibility: 'visible',
    display: 'flex',
    alignItems: 'center',
    '& a': {
      color: theme.customLinkColor,
    },
  },
}));

export default function Header() {
  const { meeting } = useAppState();

  return (
    <>
      <HeaderContainer>
        <Grid container justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
          <Grid sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
            <Logo />
          </Grid>
          <Grid sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
            <Typography variant="body1">{meeting!.topic}</Typography>
          </Grid>
          <MobileMenu sx={{ flex: 1, justifyContent: 'flex-end' }}>
            <InviteButton />
            <TroubleshootButton />
          </MobileMenu>
        </Grid>
      </HeaderContainer>
    </>
  );
}
